<fieldset class="selectable-cards-list">
  <legend class="visually-hidden">{{ groupLabel() }}</legend>
  @for (item of items(); track item[itemIdKey()]) {
    <div class="selectable-card">
      <input
        class="card-checkbox visually-hidden"
        [type]="multiSelect() ? 'checkbox' : 'radio'"
        [id]="'card-' + item[itemIdKey()]"
        [checked]="isSelected(item)"
        [disabled]="isDisabled()"
        (change)="toggleSelection(item)"
      />
      <label class="card-label" [for]="'card-' + item[itemIdKey()]">
        <div class="card-title mb-2">
          <b>{{ item[itemTitleKey()] }}</b>
        </div>
        @if (itemTemplate) {
          <ng-container
            *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"
          ></ng-container>
        }
      </label>
    </div>
  }
</fieldset>
